<template>
<div class="detail_body">
		<v-head
		title="抬头信息"
		:sdata="sdata"></v-head>
  <div class="coll">
    <h2 class="title"><span>物料明细</span></h2>
    <tab-list :tabList="sdata.details" :columns="tabColumns" setHeadBtn tabName="business-purchasein-detail" tabHeight="500">
    </tab-list>
  </div>
</div>
</template>

<script>
import vHead from './components/detail/head.vue';
import tabList  from 'components/table/list.vue';
export default{
  props:{
    sdata:Object
  },
	components:{
		vHead,
		tabList
	},
	data(){
		return{
      tabColumns:[
        {field: 'materialCode', title: '物料编码', width:100,"sortable":true},
        {field: 'materialDesc', title: '物料描述'},
        {field: 'materialGroupDesc', title: '物料组', width: 100},
        {field: 'materialTypeName', title: '物料类型', width: 100},
        {field: 'specifications', title: '规格', width: 100},
        {field: 'quantity', title: '数量', width: 100},
        {field: 'standardCurrAmount', title: '单价', width: 100},
        {field: 'currencyCode', title: '币种', width: 50,
        formatter: function (rowData,rowIndex,pagingIndex,field) {
          return "CNY";
        }},
        {field: 'basicUnitDesc', title: '基本单位', width: 100},
        {field: 'projectTxt', title: '备注', width: 150}
      ],//表头字段
		}
	},

}
</script>

<style>
</style>
